import { MenuItem, Select } from "@material-ui/core";
import React from "react";
import useStyles from "./CustomDropdown.style";

const CustomDropdownTwo = ({ value, options, updateValue, showNone, name }) => {
  const classes = useStyles();
  return (
    <div className={classes.dropdownContainer2}>
      <Select
        style={{ width: "100%" }}
        disableUnderline
        className={classes.select2}
        value={value}
        onChange={(e) => updateValue(e?.target?.value)}
      >
        {showNone ? <MenuItem value="none">All {name ?? ""}</MenuItem> : ""}
        {options.map((option) => (
          <MenuItem value={option?.value}>{option?.title}</MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default CustomDropdownTwo;
